import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { AuthCard, GoogleAuthSection, AUTH_INPUT_CLS } from "../components/AuthCard";

export default function Login() {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back to the maison.");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials.");
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Welcome Back" subtitle="Enter the House of Capra Falconeri." testId="login-page">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="login-email-input" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={AUTH_INPUT_CLS} />
        <input data-testid="login-password-input" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={AUTH_INPUT_CLS} />
        <button
          data-testid="login-submit-button"
          disabled={busy}
          className="w-full py-4 bg-capra-bronze text-capra-night text-[11px] uppercase tracking-[0.25em] font-semibold hover:bg-capra-amber transition-colors disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <GoogleAuthSection onGoogle={loginWithGoogle} testId="google-login-button" />
      <p className="text-center text-xs text-capra-muted mt-8">
        New to the maison?{" "}
        <Link to="/signup" data-testid="go-to-signup-link" className="text-capra-bronze hover:text-capra-amber transition-colors">
          Create an account
        </Link>
      </p>
    </AuthCard>
  );
}
